import { Route } from 'react-router-dom';

import OrderCreate from './order-create/order-create.component';
import { OrderDetail } from './order-detail/order-detail.component';
import { OrderOverview } from './order-overview';
import { OrderUpdate } from './order-update/order-update.component';

export function OrderRoutes() {
    return (
        <Route path='orders'>
            <Route
                index
                element={<OrderOverview />}
            />
            <Route
                path='create'
                element={<OrderCreate />}
            />
            <Route path=':orderId'>
                <Route
                    path='detail'
                    element={<OrderDetail />}
                />
                <Route
                    path='update'
                    element={<OrderUpdate />}
                />
            </Route>
        </Route>
    );
}
